import React, { useState } from 'react';




const ContentTable = ({ articles }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: 'views', direction: 'desc' });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const handleSort = (key) => {
    setSortConfig({
      key,
      direction: sortConfig?.key === key && sortConfig?.direction === 'asc' ? 'desc' : 'asc'
    });
  };

  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return 'ChevronsUpDown';
    return sortConfig?.direction === 'asc' ? 'ChevronUp' : 'ChevronDown';
  };

  const filteredArticles = articles?.filter((article) =>
  article?.title?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
  article?.category?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  const sortedArticles = [...filteredArticles]?.sort((a, b) => {
    const aValue = a?.[sortConfig?.key];
    const bValue = b?.[sortConfig?.key];
    const modifier = sortConfig?.direction === 'asc' ? 1 : -1;
    return aValue > bValue ? modifier : -modifier;
  });

  const totalPages = Math.ceil(sortedArticles?.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedArticles = sortedArticles?.slice(startIndex, startIndex + itemsPerPage);

  const getEffectivenessColor = (score) => {
    if (score >= 80) return 'text-success bg-success/10';
    if (score >= 60) return 'text-warning bg-warning/10';
    return 'text-error bg-error/10';
  };

  return;































































































































































































};

export default ContentTable;